import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";
import {ViewType} from "../../../../gd/const/views/view-type";

export const MY_WORK_CALENDAR_CONFIG : ViewPersonalConfig= {
    type            : ViewType.MY_WORK_CALENDAR,
    name            : 'My Calendar',
    icon            : 'i5-calendar',

    iconSvg         : 'isvg-view-my-calendar',
    url             : 'my-calendar',
    description     : 'Calendar view that shows all your important events and deadlines',
    defaultLocation : PersonalViewLocation.HOME_MORE,

}
